exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoContainer_42LrE {\n    padding: 0 80px;\n}\n\n.infoContainer_42LrE > h3 {\n    text-align: center;\n    font-weight: 800;\n}\n\n.conditionsContainer_1x7sf {\n    padding-top: 5px;\n}\n\n.gapSection19_33aiT {\n    height: 100px;\n}\n\n.signatureSize_1vmID img {\n    max-width: 200px;\n    max-height: 80px;\n}\n\n.centerText_27Rds {\n    text-align: center;\n}\n\n.descriptionText_1g66S {\n    font-size: 15px !important;\n}\n\n.titleSize_39sTn {\n    width: 70%;\n}\n\n.cellSize_2nFxA {\n    width: 80%;\n}\n\n.tablePadding_2Dh8j td {\n    padding: 10px;\n}\n\n.tableBorder_g1jf- {\n    width: 100%;\n}\n\n.tableBorder_g1jf- td {\n    border: none !important;\n}\n\n.inputDisplay_t57rV {\n    display: none;\n}", ""]);

// exports
exports.locals = {
	"infoContainer": "infoContainer_42LrE",
	"conditionsContainer": "conditionsContainer_1x7sf",
	"gapSection19": "gapSection19_33aiT",
	"signatureSize": "signatureSize_1vmID",
	"centerText": "centerText_27Rds",
	"descriptionText": "descriptionText_1g66S",
	"titleSize": "titleSize_39sTn",
	"cellSize": "cellSize_2nFxA",
	"tablePadding": "tablePadding_2Dh8j",
	"tableBorder": "tableBorder_g1jf-",
	"inputDisplay": "inputDisplay_t57rV"
};